/**
 * Checks if the code is running in a browser environment
 * @returns {boolean} - True if running in a browser, false otherwise
 */
export const isBrowser =
  typeof window !== 'undefined' && typeof window.document !== 'undefined';

/**
 * Like a reduce but does not require an array.
 * Only need a number and will iterate the function
 * as many times as specified.
 *
 * NOTE: This is NOT zero indexed. If you pass count=5
 * you will get 1, 2, 3, 4, 5 iteration in the callback
 * function
 *
 * @template T
 * @param {number} count - Number of iterations
 * @param {function(T, number): T} func - Function to execute on each iteration
 * @param {T} initValue - Initial value
 * @returns {T} - Final accumulated value
 */
export function iterate(count, func, initValue) {
  let value = initValue;
  for (let i = 1; i <= count; i++) {
    value = func(value, i);
  }
  return value;
}

/**
 * Generates a random number between min and max
 *
 * @param {number} min - Minimum value
 * @param {number} max - Maximum value
 * @returns {number} - Random number
 *
 * @example
 * randomNumber(1, 10) // => 5
 */
export function randomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 * Generates a random string of specified length
 *
 * @param {number} length - Length of the generated string
 * @param {string} [specials] - Special characters to include
 * @returns {string} - Random string
 *
 * @example
 * generateId(7) // => UaOKdlW
 * generateId(20, '*') // => dyJdbC*NsEgcnGjTHS*
 */
export function generateId(length, specials = '') {
  const characters = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789${specials}`;
  return iterate(
    length,
    acc => {
      return acc + characters.charAt(randomNumber(0, characters.length - 1));
    },
    ''
  );
}
